/* eslint-disable import/no-unresolved */
const MontserratBoldTtf = require('./Montserrat-Bold.ttf').default;
const MontserratBoldItalicTtf = require('./Montserrat-BoldItalic.ttf').default;
const MontserratExtraBoldTtf = require('./Montserrat-ExtraBold.ttf').default;
const MontserratExtraBoldItalicTtf =
  require('./Montserrat-ExtraBoldItalic.ttf').default;
const MontserratExtraLightTtf = require('./Montserrat-ExtraLight.ttf').default;
const MontserratExtraLightItalicTtf =
  require('./Montserrat-ExtraLightItalic.ttf').default;
const MontserratItalicTtf = require('./Montserrat-Italic.ttf').default;
const MontserratLightTtf = require('./Montserrat-Light.ttf').default;
const MontserratLightItalicTtf =
  require('./Montserrat-LightItalic.ttf').default;
const MontserratMediumTtf = require('./Montserrat-Medium.ttf').default;
const MontserratMediumItalicTtf =
  require('./Montserrat-MediumItalic.ttf').default;
const MontserratRegularTtf = require('./Montserrat-Regular.ttf').default;
const MontserratSemiBoldTtf = require('./Montserrat-SemiBold.ttf').default;
const MontserratSemiBoldItalicTtf =
  require('./Montserrat-SemiBoldItalic.ttf').default;
const MontserratThinTtf = require('./Montserrat-Thin.ttf').default;
const MontserratThinItalicTtf = require('./Montserrat-ThinItalic.ttf').default;

export const MontserratThin = {
  fontFamily: 'Montserrat',
  fontStyle: 'normal',
  fontWeight: 100,
  src: `url('${MontserratThinTtf}') format('truetype')`,
};

export const MontserratThinItalic = {
  fontFamily: 'Montserrat',
  fontStyle: 'italic',
  fontWeight: 100,
  src: `url('${MontserratThinItalicTtf}') format('truetype')`,
};

export const MontserratLight = {
  fontFamily: 'Montserrat',
  fontStyle: 'normal',
  fontWeight: 300,
  src: `url('${MontserratLightTtf}') format('truetype')`,
};

export const MontserratLightItalic = {
  fontFamily: 'Montserrat',
  fontStyle: 'italic',
  fontWeight: 300,
  src: `url('${MontserratLightItalicTtf}') format('truetype')`,
};

export const MontserratRegular = {
  fontFamily: 'Montserrat',
  fontStyle: 'normal',
  fontWeight: 400,
  src: `url('${MontserratRegularTtf}') format('truetype')`,
};

export const MontserratItalic = {
  fontFamily: 'Montserrat',
  fontStyle: 'italic',
  fontWeight: 400,
  src: `url('${MontserratItalicTtf}') format('truetype')`,
};

export const MontserratMedium = {
  fontFamily: 'Montserrat',
  fontStyle: 'normal',
  fontWeight: 600,
  src: `url('${MontserratMediumTtf}') format('truetype')`,
};

export const MontserratMediumItalic = {
  fontFamily: 'Montserrat',
  fontStyle: 'italic',
  fontWeight: 600,
  src: `url('${MontserratMediumItalicTtf}') format('truetype')`,
};

export const MontserratSemiBold = {
  fontFamily: 'Montserrat',
  fontStyle: 'normal',
  fontWeight: 600,
  src: `url('${MontserratSemiBoldTtf}') format('truetype')`,
};

export const MontserratBold = {
  fontFamily: 'Montserrat',
  fontStyle: 'normal',
  fontWeight: 700,
  src: `url('${MontserratBoldTtf}') format('truetype')`,
};

export const MontserratBoldItalic = {
  fontFamily: 'Montserrat',
  fontStyle: 'italic',
  fontWeight: 700,
  src: `url('${MontserratBoldItalicTtf}') format('truetype')`,
};

export const MontserratSemiBoldItalic = {
  fontFamily: 'Montserrat',
  fontStyle: 'italic',
  fontWeight: 600,
  src: `url('${MontserratSemiBoldItalicTtf}') format('truetype')`,
};

export const MontserratExtraBold = {
  fontFamily: 'Montserrat',
  fontStyle: 'normal',
  fontWeight: 900,
  src: `url('${MontserratExtraBoldTtf}') format('truetype')`,
};

export const MontserratExtraBoldItalic = {
  fontFamily: 'Montserrat',
  fontStyle: 'italic',
  fontWeight: 900,
  src: `url('${MontserratExtraBoldItalicTtf}') format('truetype')`,
};

export const MontserratExtraLight = {
  fontFamily: 'Montserrat',
  fontStyle: 'normal',
  fontWeight: 'regular',
  src: `url('${MontserratExtraLightTtf}') format('truetype')`,
};

export const MontserratExtraLightItalic = {
  fontFamily: 'Montserrat',
  fontStyle: 'italic',
  fontWeight: 'regular',
  src: `url('${MontserratExtraLightItalicTtf}') format('truetype')`,
};
